/**
 * Posts messages via window API.
 * We use this function to communicate with the extension.
 * "action" must be an acceptable string, see extActions.js
 * @param {{ action: string, additionalData: object }}
 */
export const sendMsgToExt = ({ action, additionalData = {} }) => {
	window.parent.postMessage({ action, additionalData: { ...additionalData } }, '*');
};
